// Default Role Type Enum mapping (Back Office)
export const DefaultRoleType = {
  Administrator: 2,
  CostingUser: 4,
  JobDeskUser: 5,
  Engineer: 6,
};

// Portal Role Type Enum mapping (Customer Portal)
export const PortalRoleType = {
  Customer: 2,
  Site: 3,
};

// Reverse mapping for display purposes (Back Office)
export const RoleTypeNames = {
  2: 'Administrator',
  4: 'CostingUser', 
  5: 'JobDeskUser',
  6: 'Engineer',
};

// Reverse mapping for display purposes (Customer Portal)
export const PortalRoleTypeNames = {
  2: 'Customer',
  3: 'Site',
};

// Function to get role names from role type IDs
export const getRoleNamesFromIds = (roleTypeIds, isPortal = false) => {
  if (!Array.isArray(roleTypeIds)) return '';
  
  const roleNames = isPortal ? PortalRoleTypeNames : RoleTypeNames;
  
  return roleTypeIds
    .map(id => roleNames[id])
    .filter(Boolean)
    .join(', ');
};

// Function to get available role options for dropdowns
export const getRoleOptions = (isPortal = false) => {
  const roleNames = isPortal ? PortalRoleTypeNames : RoleTypeNames;
  
  return Object.entries(roleNames).map(([id, name]) => ({
    id: parseInt(id),
    name: name,
    label: name,
  }));
};

// Function to get the appropriate role type names object
export const getRoleTypeNames = (isPortal = false) => {
  return isPortal ? PortalRoleTypeNames : RoleTypeNames;
};

// Function to transform API data to component format
export const transformPermissionData = (apiData) => {
  if (!Array.isArray(apiData)) return [];
  
  return apiData.map(permission => ({
    id: permission.Id.toString(),
    permissionName: permission.Name,
    isParent: permission.IsParent,
    parentPermission: permission.ParentPermissionId ? 
      apiData.find(p => p.Id === permission.ParentPermissionId)?.Name || 'Unknown' : 
      permission.IsParent ? 'Dropdown' : '',
    defaultRole: getRoleNamesFromIds(permission.DefaultRoleTypeIds),
    defaultRoleIds: permission.DefaultRoleTypeIds,
    sync: 'O', // Default sync status
    appId: permission.AppId,
    parentPermissionId: permission.ParentPermissionId,
  }));
};
